export default __webpack_public_path__ + "static/media/340.78377de6.png";